<template><div class="d-flex justify-center pa-5" style="overflow: hidden">

<div v-if="page_state == 'settings'" class="flex xs12" style="max-width: 500px">
	<p class="text-h5 text-center"> {{ $t('Game') }} </p>

	<v-menu offset-y :close-on-content-click="false" key="plus" class="list-complete-item">
	  <template v-slot:activator="{ on, attrs }">
	  	<v-chip v-bind="attrs" v-on="on"> <v-icon> {{ $mdi.Plus }} </v-icon> </v-chip>
	  </template>
	  <v-list v-if="not_selected_tasks.length > 0" class="px-3">
	  	<v-checkbox class="list-complete-item" v-for="task in not_selected_tasks" v-model="selected_tasks" :label="$t(task)" :value="task" :key="task" />
	  </v-list>
	</v-menu>

	<transition-group name="list-complete">
		<v-chip
			@click:close="handle_chip_close(task)"
			v-for="task in selected_tasks"
			close :key="task"
			class="list-complete-item ma-1"
		> {{ $t(task) }} </v-chip>

	</transition-group>

	<v-switch v-model="always_pronounce" :label="$t('Always pronounce')" />
	<v-switch v-model="translate_on_hover" :label="$t('Translate on hover')" />

	<p> {{ $t('What length of words do you want?') }} </p>

	<v-range-slider
		:tick-labels="[1,2,3,4,5,'6+']"
		min="1"
		max="6"
		ticks="always"
		tick-size="4"
		v-model="word_length"
	/>

	<v-switch v-model="competitive" :label="$t('Competitive mode')" />

	<div class="d-flex justify-center">
		<v-btn @click="game_start()"> {{ $t('Start the game') }} </v-btn>
	</div>
</div>


<div v-else-if="page_state =='game'" class="flex xs12" style="max-width: 800px">

	<div class="d-flex d-sm-none justify-space-around align-center">
		<div v-if="competitive"> {{ time_smart }} </div>
		<v-icon v-else @click="settings_dialog = true"> {{ $mdi.Cogs }} </v-icon>
		<div class="d-flex justify-center text-h3">
			{{ score_smart }}
			<v-icon x-large color="yellow"> {{ $mdi.Star }} </v-icon>
		</div>
	</div>

	<div class="d-flex">
	<div class="flex xs12 sm6 pa-5">

	<div class="task_container d-flex">

	<transition name="task">

	<div v-if="cur_type_of_task == 'Write what you hear'" :key="key">
		{{ $t('Which word do you hear?') }}
		<v-btn @click="$nao.pronounce(task.word); $refs.search_field.$el.focus()" icon><v-icon> {{ $mdi.VolumeHigh }} </v-icon></v-btn>
		<v-text-field
			autofocus :disabled="correct"
			ref="search_field"
	        dense filled disable
	    	rounded solo dense clearable
			:placeholder="$t('Type exactly what you hear')"
			v-model="cur_input"
			@keypress.enter="check_answer()"
			@keypress.ctrl.exact="$nao.pronounce(task.word)"
	    ></v-text-field>
	    
	</div>

	<div v-else-if="cur_type_of_task == 'Guess the missing element'" :key="key">
		<p> {{ $t('Which element is missing?') }} </p>
		<nao :no_popover="!translate_on_hover" v-for="el in task.word_with_missing_element" :o="el" /> = {{ task.tr.main_tr }}
		<v-text-field
			autofocus :disabled="correct"
			:label="$t('Missing element')"
			v-model="cur_input"
			@keypress.enter="check_answer()"
		/>
	</div>

	<div class="text-center" v-else-if="cur_type_of_task == 'Put elements in order'" :key="key">
		<p> {{ $t('Put the elements in the correct order:') }} </p>

		<div class="py-5"> {{ task.tr.main_tr }} </div>

		<draggable v-bind="dragOptions" v-model="task.word_shuffled" >
		    <transition-group type="transition">
		        <v-chip x-large class="text-h5" v-for="(element, index) in task.word_shuffled" :key="index">
		        	<nao :no_popover="!translate_on_hover" class="px-0" nodecor :o="element" />
		        </v-chip>
		    </transition-group>
		</draggable>

	</div>

	<div v-else-if="cur_type_of_task == 'Make an opposite'" :key="key">
		{{ $t("What's the opposite of") }} <nao :no_popover="!translate_on_hover" :o="task.word_tr.nao"/> ?
		<v-text-field
			autofocus :disabled="correct"
			:label="$t('Opposite form')"
			v-model="task.input_form"
		/>
		<v-text-field
			:disabled="correct"
			:label="$t('Meaning')"
			v-model="task.input_meaning"
			@keypress.enter="check_answer()"
		/>
	</div>

	<div v-else-if="cur_type_of_task == 'Translate from Nao'" :key="key">
		<p> {{ $t('What is the meaning of') }}
		<nao :no_popover="!translate_on_hover" v-for="el in task.word" :o="el" />
		? </p>
		<v-text-field
			autofocus :disabled="correct"
			:label="$t('Meaning')"
			v-model="cur_input"
			@keypress.enter="check_answer()"
		/>
	</div>

	</transition>
	</div>

	<div v-if="!task.result || !task.result.correct" class="text-center py-3">

		<v-btn class="mx-2" @click="skip()"> {{ $t('Skip') }} </v-btn>
		<v-btn class="mx-2 primary" @click="check_answer()"> {{ $t('Check') }} </v-btn>

	</div>

	<v-flex><transition name="alert">
	<v-alert outlined v-if="correct" type="success" > {{ $t('Correct') }}! </v-alert>
	<v-alert outlined v-else-if="task.result" type="error" > {{ $t('Nope. Try again.') }} </v-alert>
	</transition></v-flex>

	</div>

	<div style="height: 300px; flex-direction: column" class="d-none d-sm-flex text-center flex justify-space-around sm6 pa-5">

		<div class="d-flex justify-center text-h3">
			{{ score_smart }}
			<v-icon x-large color="yellow"> {{ $mdi.Star }} </v-icon>
		</div>

		<div v-if="competitive"> {{ time_smart }} </div>
		<div v-else><v-icon @click="settings_dialog = true"> {{ $mdi.Cogs }} </v-icon></div>

	</div>
	</div>
</div>

<div style="flex-direction: column; max-width: 500px" v-if="page_state == 'game_end'" class="flex xs12 d-flex justify-center text-center" >
	<p> Result </p>
	<div class="d-flex justify-center text-h3">
		{{ score_smart }}
		<v-icon x-large color="yellow"> {{ $mdi.Star }} </v-icon>
	</div>
	<div class="d-flex justify-center text-h3 py-5">
		<v-btn @click="page_state = 'settings'"> Play one more </v-btn>
	</div>
</div>

<v-snackbar
  v-model="snackbar"
>
  You must have at least 1 task.
  <template v-slot:action="{ attrs }">
    <v-btn
      color="pink"
      text
      v-bind="attrs"
      @click="snackbar = false"
    >
      Close
    </v-btn>
  </template>
</v-snackbar>

    <v-dialog v-model="settings_dialog" v-bind="$vuetify.breakpoint.xs ? {fullscreen: true, transition: 'dialog-bottom-transition'} : {width: 500}">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="settings_dialog = false">
            <v-icon> {{ $mdi.Close }} </v-icon>
          </v-btn>
          <v-toolbar-title> {{ $t('Settings') }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="settings_dialog = false">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Tasks</v-list-item-title>
              <v-list-item-subtitle>You will be given a random task from the list below</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        	<div class="pa-3">
        		<v-menu offset-y :close-on-content-click="false" key="plus" class="list-complete-item">
				  <template v-slot:activator="{ on, attrs }">
				  	<v-chip v-bind="attrs" v-on="on"> <v-icon> {{ $mdi.Plus }} </v-icon> </v-chip>
				  </template>
				  <v-list v-if="not_selected_tasks.length > 0" class="px-3">
				  	<v-checkbox class="list-complete-item" v-for="task in not_selected_tasks" v-model="selected_tasks" :label="$t(task)" :value="task" :key="task" />
				  </v-list>
				</v-menu>

				<transition-group name="list-complete">
					<v-chip
						@click:close="handle_chip_close(task)"
						v-for="task in selected_tasks"
						close :key="task"
						class="list-complete-item ma-1"
					> {{ $t(task) }} </v-chip>

				</transition-group>
			</div>

        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>General</v-subheader>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="translate_on_hover"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> {{ $t('Translate on hover') }} </v-list-item-title>
              <v-list-item-subtitle>This is especially good for beginners</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="always_pronounce"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> {{ $t('Always pronounce') }} </v-list-item-title>
              <v-list-item-subtitle>The word will be pronounced in all tasks except the ones where you need to solve the word</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

</div></template>

<script>

/*
:duration="200"
	    enter-active-class="animated fadeIn"
	    leave-active-class="animated fadeOut"
*/

import nao from '@/components/Naoword'

let words_by_length, make_task, game_interval;


function random_element(array) {
	return array[Math.floor(Math.random()*array.length)];
}

function random_integer_between(a, b) {
	return Math.floor(Math.random()*(b-a+1) ) + a;
}

function random_word_with_length(word_length) {
	let words = words_by_length[ random_integer_between(word_length[0], word_length[1] ) ];
	return random_element(words);
}

function min_two(word_length) {
	return word_length.map(x => x == 1 ? 2 : x);
}

function shuffle(A) {
	for (let i=0; i < A.length; i++) {
		let r = Math.floor(Math.random()*A.length);
		[ A[i], A[r] ] = [ A[r], A[i] ];
	}
}

function pad(x, n) {
	x += '';
	while(x.length < n) x = '0' + x;
	return x;
}

import draggable from 'vuedraggable'

export default {
	components: {draggable, nao},
	data() {
		return {
			cur_type_of_task: null,
			selected_tasks: ['Write what you hear', 'Make an opposite'],
			cur_input: '',
			word_length: [1,2],
			always_pronounce: false,
			task: {},
			translate_on_hover: false,
			key: 0,
			snackbar: false,
			settings_dialog: false,
			score: 0,
			time: 0,
			competitive: true,
			page_state: 'settings',
		}
	},
	watch: {
		time(nv) {
			if (nv < 0) this.game_stop();
		}
	},
	methods: {
		next_task() {
			this.cur_input = '';
			this.key++;
			this.cur_type_of_task = random_element(this.selected_tasks);
			this.task = make_task[this.cur_type_of_task]();
		},
		check_answer() {
			//this.task.result = this.check();
			this.$set(this.task, 'result', this.check() );
			/*
			if (c.correct) {
				this.$set(this.task, 'answer', 'correct');
				this.score += c.score;
			}
			else this.$set(this.task, 'answer', 'incorrect');
			*/
			if (this.task.result.correct) {
				this.score += this.task.result.score * (this.selected_tasks.length**0.2) ;
				setTimeout(this.next_task, this.competitive ? 500 : 1000);
			}
		},
		handle_chip_close(task) {
			if (this.selected_tasks.length == 1) {
				this.snackbar = true;
				return;
			}
			this.selected_tasks.splice(this.selected_tasks.indexOf(task), 1);
		},
		game_start() {
			//setTimeout( this.game_stop, this.time*1000);
			game_interval = setInterval(function() {
				localStorage.game_in_progress = new Date().getTime();
			}, 1000);
			
			this.time = 5*60;
			this.page_state = 'game';
			if (this.competitive) {
				this.time--;
				this.timer = setInterval( () => this.time--, 1000);
			}
			this.next_task();
		},
		game_stop() {
			clearInterval(this.timer);
			clearInterval(game_interval);
			this.time = 0;
			this.page_state = 'game_end';
		},
		skip() {
			this.time -= 5;
			this.next_task();
		}
	},
	computed: {
		not_selected_tasks() {
			return this.all_tasks.filter(task => !this.selected_tasks.includes(task));
		},
		dragOptions() {
			return {
				animation: 200,
				group: "description",
				disabled: false,
				ghostClass: "ghost"
			};
		},
		time_smart() {
			let seconds = this.time % 60;
			let minutes = (this.time - seconds) / 60;
			return minutes + ' : ' + pad(seconds, 2);
		},
		score_smart() {
			return pad( Math.floor(this.score), 3);
		},
		hover_coef() {
			return this.translate_on_hover ? 1 : 2;
		},
		correct() {
			return this.task.result && this.task.result.correct;
		}
	},
	beforeDestroy() {
		clearInterval(game_interval);
	},
	created() {
		words_by_length = this.$nao.get_words_by_length();

		let G = this;

		make_task = {
			'Write what you hear'() {
				let word = random_word_with_length(G.word_length);
				let tr = G.$nao.tr_from_Nao(word.join(''));

				G.check = function() {
					if (G.cur_input == word.join('')) {
						return {correct: true, score: (word.join('').length/2)**1.4 };
					}
					else return {};
				}
				G.$nao.pronounce(word);

				return {word, tr};
			},
			'Guess the missing element'() {
				let word = random_word_with_length(min_two(G.word_length));
				let tr = G.$nao.tr_from_Nao(word.join(''));

				let n = random_integer_between(0, word.length - 1);
				let word_with_missing_element = word.slice(0);
				let missing_el = word_with_missing_element[n];
				word_with_missing_element[n] = '___';

				G.check = function() {
					if (G.cur_input == missing_el) {
						return {correct: true, score: (word.length**1.3) * G.hover_coef};
					}
					else return {};
				}

				return {word, tr, word_with_missing_element};
			},
			'Put elements in order'() {
				let word = random_word_with_length(min_two(G.word_length));
				let word_shuffled = word.slice(0);
				shuffle(word_shuffled);

				let tr = G.$nao.tr_from_Nao(word.join(''));

				G.check = function() {
					if (G.task.word_shuffled.join('') == word.join('')) {
						return {correct: true, score: (word.length-1)**2 * G.hover_coef};
					}
					else return {};
				}

				return {word, word_shuffled, tr};
			},
			'Make an opposite'() {
				let word, opp, opp_tr;
				let WL = G.word_length;
				if (WL[0] > 4) WL[0] = 4;

				while (!opp_tr) {
					word = random_word_with_length(WL);
					opp = G.$nao.make_opposite(word);
					if (opp != null) opp_tr = G.$nao.tr_from_Nao(opp.join(''));
				}

				let word_tr = G.$nao.tr_from_Nao(word.join(''));

				G.check = function() {
					if (G.task.input_form == opp.join('') && G.$nao.tr_to_Nao(G.task.input_meaning).includes(opp.join('')) ) {
						return {correct: true, score: word.length*2 * (G.hover_coef**2) };
					}
					else return {};
				}

				return {word, word_tr, opp, opp_tr, input_form: '', input_meaning: ''};
			},
			'Translate from Nao'() {
				let word = random_word_with_length(min_two(G.word_length));
				let tr = G.$nao.tr_from_Nao(word.join(''));

				G.check = function() {
					if (G.$nao.tr_to_Nao(G.cur_input).includes(word.join('')) ) {
						return {correct: true, score: (word.length**1.5) * (G.hover_coef**2) };
					}
					else return {};
				}

				if (this.always_pronounce) G.$nao.pronounce(word);

				return {word, tr};
			}
		}

		this.all_tasks = Object.keys(make_task);
		//this.game_start();
	}
}


</script>

<style scoped>

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.list-complete-item {
	transition: all 0.3s;
	-webkit-user-select: none;
	user-select: none;
}

.list-complete-enter, .list-complete-leave-to {
	opacity: 0;
	transform: translateX(-30px);
}

.list-complete-leave-active {
	position: absolute;
}


.task-enter-active, .task-leave-active  {
	transition: all .5s;
}

.task-enter {
	opacity: 0;
	transform: translateX(-200px);
}

.task-leave-to {
	opacity: 0;
	transform: translateX(200px);
}



.alert-leave-active, .alert-enter-active {
	transition: all .2s linear;
}

.alert-enter {
	opacity: 0;
	transform: scale(0.5);
}

.alert-leave-to {
	opacity: 0;
	transform: scale(0.5);
}



.task_container {
	min-height: 200px;
	position: relative;
}

.task_container > div {
	position: absolute;
	width: 100%;
}


</style>